// Set to 0 before production deploy.
window.SAVE_SPINNER_DEBUG_DELAY_MS = 0;

window.getSaveSpinnerRemainingDelayMs = function (button) {
	const delayMs = Math.max(0, parseInt(window.SAVE_SPINNER_DEBUG_DELAY_MS, 10) || 0);
	if (!delayMs) {
		return 0;
	}
	if (!button) {
		return delayMs;
	}
	const $btn = button && button.jquery ? button : jQuery(button);
	if (!$btn.length) {
		return delayMs;
	}
	const startedAt = parseInt($btn.attr('data-save-spinner-started-at'), 10);
	if (!startedAt) {
		return delayMs;
	}
	return Math.max(0, delayMs - (Date.now() - startedAt));
};

window.delaySaveSpinnerAction = function (callback, button) {
	const wait = window.getSaveSpinnerRemainingDelayMs(button);
	if (wait > 0) {
		setTimeout(callback, wait);
		return;
	}
	callback();
};

window.finishSaveSpinnerAction = function (button, buttonText, callback) {
	window.delaySaveSpinnerAction(function () {
		if (typeof callback === 'function') {
			callback();
		}
		window.removeSpinnerFromButton(button, buttonText);
	}, button);
};

window.addSpinnerToButton = function (button, labelText) {
	const $btn = button && button.jquery ? button : jQuery(button);
	if (!$btn.length) {
		return false;
	}
	if ($btn.prop('disabled') || $btn.attr('data-kt-indicator') === 'on') {
		return false;
	}

	const label = labelText || $btn.text().trim();
	const width = $btn.outerWidth();

	$btn.data('save-spinner-label', label);
	$btn.attr('data-save-spinner-started-at', String(Date.now()));
	$btn.prop('disabled', true);
	$btn.attr('data-kt-indicator', 'on');
	if (width) {
		$btn.css('min-width', width + 'px');
	}
	$btn.html(
		'<span class="indicator-progress" style="display: inline-flex !important; align-items: center; justify-content: center;">' +
		'<span class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span>' +
		'</span>'
	);
	return true;
};

window.removeSpinnerFromButton = function (button, buttonText) {
	const $btn = button && button.jquery ? button : jQuery(button);
	if (!$btn.length) {
		return;
	}

	const doRemove = function () {
		const label = buttonText || $btn.data('save-spinner-label') || 'Save';
		$btn.prop('disabled', false);
		$btn.removeAttr('data-kt-indicator');
		$btn.removeAttr('data-save-spinner-started-at');
		$btn.css('min-width', '');
		$btn.html(label);
		$btn.removeData('save-spinner-label');
	};

	const delayMs = window.getSaveSpinnerRemainingDelayMs(button);
	if (delayMs > 0) {
		setTimeout(doRemove, delayMs);
		return;
	}

	doRemove();
};

window.COLUMN_OPTIONS_FORM_SELECTOR = [
	'#kt_contacts_column_options_form',
	'#kt_companies_column_options_form',
	'form[id$="_columns_form"]',
	'form[id^="kt_column_options_"][id$="_form"]',
].join(', ');

window.initSaveButtonSpinnerBindings = function () {
	if (window.__saveButtonSpinnerBindingsInit) {
		return;
	}
	window.__saveButtonSpinnerBindingsInit = true;

	document.addEventListener('submit', function (e) {
		const form = e.target;
		if (!(form instanceof HTMLFormElement) || !form.matches(window.COLUMN_OPTIONS_FORM_SELECTOR)) {
			return;
		}

		let submitter = e.submitter;
		if (!submitter) {
			submitter = form.querySelector('[type="submit"]')
				|| document.querySelector('button[type="submit"][form="' + form.id + '"], input[type="submit"][form="' + form.id + '"]');
		}
		if (!submitter) {
			return;
		}

		if (form.dataset.saveSpinnerDelayedSubmit === '1') {
			delete form.dataset.saveSpinnerDelayedSubmit;
			return;
		}

		const debugDelayMs = Math.max(0, parseInt(window.SAVE_SPINNER_DEBUG_DELAY_MS, 10) || 0);
		if (debugDelayMs > 0) {
			e.preventDefault();
			if (!window.addSpinnerToButton(submitter)) {
				return;
			}
			window.delaySaveSpinnerAction(function () {
				form.dataset.saveSpinnerDelayedSubmit = '1';
				if (typeof form.requestSubmit === 'function') {
					form.requestSubmit(submitter);
				} else {
					form.submit();
				}
			}, submitter);
			return;
		}

		if (!window.addSpinnerToButton(submitter)) {
			e.preventDefault();
		}
	}, true);
};
